import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ControlsFeatureParams = FeatureHoookParams;
export const useShowControlsFeature = (_params: ControlsFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showControls: boolean }}>();

	useSubscription(controller, false, [['layer-option-controls', '*']]);

	const controllerSupportsFeature = (controller?.options?.showControls ?? null) !== null;
	const showLayer = controller?.options?.showControls ?? false;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.controls} ${lang.layer.layer}`;
	})();

	return {
		name: 'showControls',
		label: lang.layer.label.controls,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showControls = !showLayer;
				controller.publish('layer-option-controls', 'update', { ref: '', data: { value: controller.options.showControls } });
			}
		}
	};
};
